import React from 'react';
import { Switch, Route } from 'react-router-dom';

// pages
import List from './List';
import Info from './Info';

class Service extends React.PureComponent {
    render() {
        return (
            <Switch>
                <Route exact path='/mateApply/list' component={List} />
                <Route exact path='/mateApply/info/:id' component={Info} />
            </Switch>
        );
    }
}
export default Service;
